import React, { useEffect, useState } from 'react'
import { useParams } from "react-router-dom";
import axios from 'axios'
import { apiRequest } from '../../store/allApi';


function Permissions() {
    let { id } = useParams();
    const [user, setUser] = useState();
    const [set, setSet] = useState();
    const access_token = localStorage.getItem("token")
    const beckendLocalApiUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
    const beckendLiveApiUrl = process.env.REACT_APP_BACKEND_LIVE_API;
    const nodeMode = process.env.NODE_ENV;
    if (nodeMode === "development") {
      var baseUrl = beckendLocalApiUrl;
    } else {
      baseUrl = beckendLiveApiUrl;
    }

    const headers = {
        Authorization: `Bearer ${access_token}`
    }
    const getUser =async () => {
        let access_token = localStorage.getItem("token")
        let headers = {
            Authorization: `Bearer ${access_token}`
        }
      
           try {
                          const res = await apiRequest(`get_user/${id}`,"GET", null,headers)
                         if (res.data) {
                            if (res.data.Permissions) {
                                            if (res.data.Permissions.length) {
                                                setSet(true);
                                            }
                                        }
                                        setUser(res.data)
                         }
                            } catch (e) {
                                        if (e.response.status == 401) {
                    localStorage.removeItem('token');
                }
                            }
                            finally {
                            }
    }
    const grantAccess =async () => {
        let access_token = localStorage.getItem("token")
        let headers = {
            Authorization: `Bearer ${access_token}`
        }
      
           try {
                          const res = await apiRequest(`agent/permission/${id}`,"PATCH", null,headers)
                         if (res) {
                                             getUser();
                         }
                            } catch (e) {
                              console.log(e);
                                           if (e.response.status == 401) {
                                                localStorage.removeItem('token');
                                            } }
                            finally {
                            }
    }
    const giveAccess = async(Status,ID) => {
      
        try {
            const res = await apiRequest(`agent/permission/nested/${ID}`,"POST", {Status},headers)
           if (res) {
                               getUser();
           }
              } catch (e) {
                console.log(e);
                             if (e.response.status == 401) {
                                  localStorage.removeItem('token');
                              } }
              finally {
              }
    }
    useEffect(() => {
        getUser();
    }, [])

    return (
        <div className="row ">
            <div className="col-12 grid-margin">
                {user && <div className="card">
                    {!Boolean(set) && <button type="button" className="btn btn-success btn-lg" onClick={grantAccess}>Grant Permissions</button>}
                    {Boolean(set) && <div className='card-body'>
                        <h4 className="card-title">Pages Permission</h4>
                        <ul className="list-group list-group-flush">
                            {user.Permissions.map((item, key) =>
                                <li key={key} className="list-group-item">
                                    <div>
                                        <div>
                                            {item.Permission}
                                        </div>
                                        <div>
                                            <div className="custom-control custom-switch">
                                                <input type="checkbox" checked={item.Status} onChange={(e)=>giveAccess(!(item.Status),item._id)} className="custom-control-input" id={item.Permission} />
                                                <label className="custom-control-label" htmlFor={item.Permission}>Allow to access</label>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )}
                        </ul>
                    </div>}
                </div>}
            </div>
        </div>
    )
}

export default Permissions